export default __webpack_public_path__ + "static/media/Pamela Price.4ffaecb9.jpg";